import React from 'react';
import './LicensePageWallio.css';

function LicensePageWallio() {
    return (
        <div className="license-container">
            <h1>Copyright ©</h1>
            <p>
                Copyright © 2024, Yuzult. All rights reserved.
            </p>
            <p>
                This notice applies to all content and materials contained within the Wallpaper io application or QR YZT plus application, including, but not limited to, text, images, logos, and code. No part of this application may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the owner, Yuzult.
            </p>
            <p>
                For permission requests, write to the owner at the address provided within the application.
            </p>
        </div>
    );
}

export default LicensePageWallio;
